<template>
  <div class="crud-container" data-aos="fade-right">
    <CrudToolbar
      title="Mtto Moldes"
      v-model="filtroTexto"
      searchPlaceholder="Buscar por molde, máquina o evento"
    >
      <template #actions>
        <button class="btn btn-exportar btn-nuevo-header" @click="exportarExcel">
          <i class="bi bi-file-earmark-excel"></i>
          <span class="btn-header-texto ms-2">Exportar</span>
        </button>
        <button class="btn btn-nuevo btn-nuevo-header" @click="abrirModalNuevo">
          <i class="bi bi-plus-lg"></i>
          <span class="btn-header-texto ms-2">Nuevo</span>
        </button>
      </template>
    </CrudToolbar>

    <div class="divisan-table-container shadow-lg d-none d-lg-block">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>
      <table v-else class="table table-divisan align-middle mb-0">
        <thead>
          <tr>
            <th class="ps-4">
              <ColumnFilterMenu
                field="fecha_mantenimiento"
                label="Fecha mtto"
                type="date"
                :filterable="false"
                :items="eventosPorTexto"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                @update:sort="onSort"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="molde_nombre"
                label="Molde"
                :items="eventosPorTexto"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                v-model="filtroMoldeSet"
                @update:sort="onSort"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="tipo_evento_nombre"
                label="Evento"
                :items="eventosPorTexto"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                v-model="filtroEventoSet"
                @update:sort="onSort"
              />
            </th>
            <th class="text-end">
              <ColumnFilterMenu
                field="ciclos_totales"
                label="Ciclos totales"
                type="number"
                :filterable="false"
                :items="eventosPorTexto"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                @update:sort="onSort"
              />
            </th>
            <th class="text-end">
              <ColumnFilterMenu
                field="maquina"
                label="Maquina"
                :items="eventosPorTexto"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                v-model="filtroMaquinaSet"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ev in eventosPaginados" :key="ev.id">
            <td class="ps-4">
              <div class="fecha-texto">{{ formatFecha(ev.fecha_mantenimiento) }}</div>
            </td>
            <td>
              <span class="badge-molde">{{ ev.molde_nombre }}</span>
            </td>
            <td>
              <span class="badge-evento">{{ ev.tipo_evento_nombre }}</span>
            </td>
            <td class="text-end fw-bold text-cafe">
              {{ ev.ciclos_totales.toLocaleString() }}
            </td>
            <td class="text-end">
              <span class="delta-texto">{{ ev.maquina.toLocaleString() }}</span>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <button
                  class="btn-circular"
                  @click="abrirModalFotos(ev)"
                  title="Ver fotos"
                >
                  <i
                    :class="
                      ev.has_images
                        ? 'bi bi-eye-fill text-primary'
                        : 'bi bi-eye text-muted opacity-50'
                    "
                  ></i>
                </button>
                <button
                  class="btn-circular"
                  @click="abrirModalDetalle(ev)"
                  title="Detalles"
                >
                  <i class="bi bi-info-circle text-dark"></i>
                </button>
                <button class="btn-circular text-danger" @click="confirmarEliminar(ev)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="eventosPaginados.length === 0">
            <td colspan="6" class="text-center py-5 text-cafe opacity-50 fw-bold">
              No se encontraron resultados
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="totalPaginas > 1"
        class="pagination-wrapper d-flex justify-content-between align-items-center px-4 py-3"
      >
        <small class="text-cafe fw-bold"
          >Página {{ paginaActual }} de {{ totalPaginas }}</small
        >
        <div class="d-flex gap-2">
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="cambiarPagina(paginaActual - 1)"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="cambiarPagina(paginaActual + 1)"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="d-lg-none">
      <div
        v-for="ev in eventosPaginados"
        :key="'mob-' + ev.id"
        class="divisan-mobile-card mb-2 px-3 py-2 shadow-sm"
      >
        <!-- Fila 1: nombre del molde + botones -->
        <div class="d-flex justify-content-between align-items-start mb-1">
          <span class="card-name">{{ ev.molde_nombre }}</span>
          <div class="d-flex gap-2 flex-shrink-0 ms-2">
            <button
              class="btn-circular-sm"
              @click="abrirModalFotos(ev)"
              title="Ver fotos"
            >
              <i
                :class="
                  ev.has_images
                    ? 'bi bi-eye-fill text-primary'
                    : 'bi bi-eye text-muted opacity-50'
                "
              ></i>
            </button>
            <button
              class="btn-circular-sm"
              @click="abrirModalDetalle(ev)"
              title="Detalles"
            >
              <i class="bi bi-info-circle text-dark"></i>
            </button>
            <button
              class="btn-circular-sm"
              @click="confirmarEliminar(ev)"
              title="Eliminar"
            >
              <i class="bi bi-trash text-danger"></i>
            </button>
          </div>
        </div>

        <!-- Fila 2: tipo de evento, en su propio renglón -->
        <div class="mb-1">
          <span class="badge-evento">{{ ev.tipo_evento_nombre }}</span>
        </div>

        <!-- Fila 3: máquina a la izquierda, fecha a la derecha -->
        <div class="d-flex justify-content-between align-items-end mt-1">
          <div>
            <span class="card-meta-label">Máquina</span>
            <div class="small fw-bold text-cafe">{{ ev.maquina }}</div>
          </div>
          <div class="text-end">
            <span class="card-meta-label">Fecha</span>
            <div class="fecha-texto small">{{ formatFecha(ev.fecha_mantenimiento) }}</div>
          </div>
        </div>
      </div>

      <!-- Paginación móvil -->
      <div
        v-if="totalPaginas > 1"
        class="pagination-mobile d-flex justify-content-between align-items-center px-1 py-2 mt-1"
      >
        <button
          class="btn-pag-mobile"
          :disabled="paginaActual === 1"
          @click="cambiarPagina(paginaActual - 1)"
        >
          <i class="bi bi-chevron-left"></i> Anterior
        </button>
        <small class="text-cafe fw-bold">{{ paginaActual }} / {{ totalPaginas }}</small>
        <button
          class="btn-pag-mobile"
          :disabled="paginaActual === totalPaginas"
          @click="cambiarPagina(paginaActual + 1)"
        >
          Siguiente <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="modal fade" id="modalEvento" tabindex="-1" ref="modalElement">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-0">
            <h5 class="fw-bold text-cafe">Registrar nueva actividad</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <form @submit.prevent="guardarIntervencion">
            <div class="modal-body">
              <div class="row g-4">
                <!-- COLUMNA IZQUIERDA -->
                <div class="col-md-6">
                  <div class="row g-3">
                    <div class="col-12">
                      <label class="form-label label-divisan small">Molde</label>
                      <select
                        v-model="form.molde"
                        class="form-select divisan-input-modal"
                        required
                      >
                        <option value="" disabled selected>Selecciona un molde</option>
                        <option v-for="m in catMoldes" :key="m.id" :value="m.id">
                          {{ m.nombre }}
                        </option>
                      </select>
                    </div>

                    <div class="col-12">
                      <label class="form-label label-divisan small"
                        >Estatus del molde tras el evento</label
                      >
                      <select
                        v-model="form.estatus_molde"
                        class="form-select divisan-input-modal"
                      >
                        <option value="OK">✅ OK — Apto para producción</option>
                        <option value="NO_USAR">🚫 No usar — Obsoleto o dañado</option>
                        <option value="CONDICIONADO">
                          ⚠️ Condicionado — Pendiente de validación
                        </option>
                        <option value="COMBINADO">
                          🔄 Molde combinado — Requiere cambio de insertos
                        </option>
                      </select>
                      <div class="form-text" style="font-size: 0.7rem; color: var(--d-green)">
                        Al guardar, el estatus del molde se actualizará automáticamente.
                      </div>
                    </div>

                    <div class="col-12">
                      <label class="form-label label-divisan small">Tipo de evento</label>
                      <select
                        v-model="form.tipo_evento"
                        class="form-select divisan-input-modal"
                        required
                      >
                        <option value="" disabled selected>
                          Selecciona un tipo de evento
                        </option>
                        <option v-for="t in catTipos" :key="t.id" :value="t.id">
                          {{ t.nombre }}
                        </option>
                      </select>
                    </div>

                    <div class="col-12">
                      <label class="form-label label-divisan small">Máquina</label>
                      <input
                        v-model="form.maquina"
                        type="text"
                        class="form-control divisan-input-modal"
                        required
                        placeholder="Maquina de molde"
                      />
                    </div>

                    <div class="col-12">
                      <label class="form-label label-divisan small">Ciclos totales</label>
                      <input
                        v-model.number="form.ciclos_totales"
                        type="number"
                        class="form-control divisan-input-modal"
                        required
                        min="0"
                      />
                    </div>

                    <div class="col-12">
                      <label class="form-label label-divisan small">
                        Fecha y hora del evento
                      </label>
                      <input
                        v-model="form.fecha_mantenimiento"
                        type="datetime-local"
                        class="form-control divisan-input-modal"
                        required
                      />
                    </div>
                  </div>
                </div>

                <!-- COLUMNA DERECHA -->
                <div class="col-md-6">
                  <div class="row g-3">
                    <!-- SWITCH -->
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="switchRefaccion"
                          v-model="form.requirio_refaccion"
                        />
                        <label
                          class="form-check-label label-divisan small ms-2"
                          for="switchRefaccion"
                        >
                          ¿Requirió refacción?
                        </label>
                      </div>
                    </div>

                    <!-- DETALLE CONDICIONAL -->
                    <div v-if="form.requirio_refaccion" class="col-12">
                      <label class="form-label label-divisan small">
                        Detalle de refacción
                      </label>
                      <textarea
                        v-model="form.refaccion"
                        class="form-control divisan-input-modal"
                        rows="2"
                        placeholder="Cual | Cuantas, Costo, Proveedor, Tiempo de entrega, Inventario"
                      ></textarea>
                    </div>

                    <!-- PDF CONDICIONAL -->
                    <div v-if="form.requirio_refaccion" class="col-12">
                      <label class="form-label label-divisan small">
                        Cotización (PDF)
                      </label>
                      <input
                        type="file"
                        @change="handlePdfUpload"
                        class="form-control divisan-input-modal"
                        accept="application/pdf"
                      />
                    </div>

                    <!-- DESCRIPCIÓN -->
                    <div class="col-12">
                      <label class="form-label label-divisan small">
                        Descripción de actividad
                      </label>
                      <textarea
                        v-model="form.descripcion"
                        class="form-control divisan-input-modal"
                        rows="2"
                        required
                      ></textarea>
                    </div>

                    <!-- FOTOS -->
                    <div class="col-12">
                      <label class="form-label label-divisan small">
                        Fotos de evidencia
                      </label>
                      <input
                        type="file"
                        @change="handleFileUpload"
                        multiple
                        class="form-control divisan-input-modal"
                        accept="image/*"
                      />
                    </div>

                    <!-- COMENTARIOS -->
                    <div class="col-12">
                      <label class="form-label label-divisan small">
                        Comentarios
                      </label>
                      <textarea
                        v-model="form.comentarios"
                        class="form-control divisan-input-modal"
                        rows="2"
                        placeholder="Descripción del estatus seleccionado (ej. por qué quedó condicionado)"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 pt-0">
              <button
                type="submit"
                class="btn btn-nuevo w-100 py-2 d-flex justify-content-center align-items-center gap-2"
                :disabled="guardando"
              >
                <span v-if="guardando" class="spinner-border spinner-border-sm"></span>
                <span>
                  {{ guardando ? "Guardando mantenimiento..." : "Finalizar registro" }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalFotos" tabindex="-1" ref="modalFotosElement">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content divisan-modal-dark border-0">
          <div class="modal-header border-0 pb-0">
            <h6 class="modal-title text-dark fw-bold">
              Evidencias: {{ seleccionado?.molde_nombre }}
            </h6>
            <button
              type="button"
              class="btn-close btn-close-dark"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <div id="carouselFotos" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner rounded-3">
                <div
                  v-for="(img, idx) in seleccionado?.imagenes"
                  :key="idx"
                  :class="['carousel-item', { active: idx === 0 }]"
                >
                  <img
                    :src="img.imagen"
                    class="d-block w-100 object-fit-cover"
                    style="height: 320px"
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselFotos"
                data-bs-slide="prev"
              >
                <span class="carousel-control-prev-icon"></span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselFotos"
                data-bs-slide="next"
              >
                <span class="carousel-control-next-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalDetalles" tabindex="-1" ref="modalDetallesElement">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content divisan-modal border-0">
          <!-- HEADER -->
          <div class="modal-header border-0 pb-1">
            <div>
              <h5 class="fw-bold text-cafe mb-0">
                {{ seleccionado?.molde_nombre }}
              </h5>

              <div class="d-flex align-items-center gap-2 mt-1">
                <span
                  :class="[
                    'badge-evento',
                    seleccionado?.tipo_evento_nombre?.toLowerCase(),
                  ]"
                >
                  {{ seleccionado?.tipo_evento_nombre }}
                </span>

                <small class="fecha-texto">
                  {{ formatFechaCompleta(seleccionado?.fecha_mantenimiento) }}
                </small>
              </div>
            </div>

            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-2">
            <!-- DATOS EN GRID -->
            <div class="detalle-grid mb-3">
              <div>
                <span class="detalle-mini-label">Máquina</span>
                <div class="detalle-mini-valor">{{ seleccionado?.maquina }}</div>
              </div>

              <div>
                <span class="detalle-mini-label">Ciclos</span>
                <div class="detalle-mini-valor">
                  {{ seleccionado?.ciclos_totales?.toLocaleString() }}
                </div>
              </div>
            </div>

            <!-- DESCRIPCIÓN -->
            <div class="detalle-seccion mb-3">
              <span class="detalle-mini-label">Descripción</span>
              <div class="detalle-mini-valor">
                {{ seleccionado?.descripcion || "Sin descripción" }}
              </div>
            </div>

            <!-- COMENTARIOS -->
            <div v-if="seleccionado?.comentarios" class="detalle-seccion mb-3">
              <span class="detalle-mini-label">Comentarios</span>
              <div class="detalle-mini-valor">
                {{ seleccionado?.comentarios }}
              </div>
            </div>

            <!-- REFACCIÓN -->
            <div v-if="seleccionado?.refaccion" class="detalle-seccion mb-3">
              <span class="detalle-mini-label text-verde"> Refacción utilizada </span>
              <div class="detalle-mini-valor">
                {{ seleccionado?.refaccion }}
              </div>
            </div>

            <!-- COTIZACIONES -->
            <div v-if="seleccionado?.cotizaciones?.length" class="detalle-seccion">
              <span class="detalle-mini-label"> Cotización </span>

              <a
                v-for="c in seleccionado?.cotizaciones"
                :key="c.id"
                :href="c.documento"
                target="_blank"
                class="btn btn-sm btn-exportar mt-2"
              >
                Ver PDF
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import {
  getMantenimientos,
  getMoldes,
  getTiposEvento,
  crearMantenimiento,
  eliminarMantenimiento,
} from "@/utils/api_backend";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import ColumnFilterMenu from "@/components/Shared/ColumnFilterMenu.vue";

// ── Estado ─────────────────────────────────────────────────
const eventos = ref([]);
const catMoldes = ref([]);
const catTipos = ref([]);
const loading = ref(false);
const guardando = ref(false);
const filtroTexto = ref("");
const filtroMoldeSet = ref(new Set());
const filtroMaquinaSet = ref(new Set());
const filtroEventoSet = ref(new Set());
const seleccionado = ref(null);
const selectedFiles = ref([]);
const selectedPdf = ref(null);
const paginaActual = ref(1);
const porPagina = ref(5);
const ordenCampo = ref("fecha_mantenimiento");
const ordenAsc = ref(false);

function onSort({ field, asc }) {
  ordenCampo.value = field;
  ordenAsc.value = asc;
}

const form = ref({
  molde: "",
  tipo_evento: "",
  maquina: "",
  ciclos_totales: 0,
  fecha_mantenimiento: "",
  descripcion: "",
  requirio_refaccion: false,
  refaccion: "",
  activo: true,
  estatus_molde: "OK",
  comentarios: "",
});

// ── Refs para modales Bootstrap ────────────────────────────
const modalElement = ref(null);
const modalFotosElement = ref(null);
const modalDetallesElement = ref(null);

let modalInstance = null;
let modalFotosInstance = null;
let modalDetallesInstance = null;

// Resetear página al filtrar
watch([filtroTexto, filtroMoldeSet, filtroMaquinaSet, filtroEventoSet], () => {
  paginaActual.value = 1;
});

// ── Computed ───────────────────────────────────────────────
// Filtrado solo por texto libre — es el universo que alimenta las listas de
// valores únicos de cada ColumnFilterMenu (para que reflejen la búsqueda).
const eventosPorTexto = computed(() => {
  const q = filtroTexto.value.toLowerCase();
  if (!q) return eventos.value;
  return eventos.value.filter(
    (e) =>
      (e.maquina || "").toLowerCase().includes(q) ||
      (e.molde_nombre || "").toLowerCase().includes(q) ||
      (e.tipo_evento_nombre || "").toLowerCase().includes(q)
  );
});

const eventosFiltrados = computed(() =>
  eventosPorTexto.value.filter((e) => {
    const matchMolde = !filtroMoldeSet.value.size || filtroMoldeSet.value.has(e.molde_nombre);
    const matchMaquina = !filtroMaquinaSet.value.size || filtroMaquinaSet.value.has(e.maquina);
    const matchEvento =
      !filtroEventoSet.value.size || filtroEventoSet.value.has(e.tipo_evento_nombre);
    return matchMolde && matchMaquina && matchEvento;
  })
);

const eventosOrdenados = computed(() => {
  return [...eventosFiltrados.value].sort((a, b) => {
    let valA = a[ordenCampo.value];
    let valB = b[ordenCampo.value];
    if (typeof valA === "string") {
      valA = valA.toLowerCase();
      valB = valB.toLowerCase();
    }
    if (valA < valB) return ordenAsc.value ? -1 : 1;
    if (valA > valB) return ordenAsc.value ? 1 : -1;
    return 0;
  });
});

const totalPaginas = computed(() =>
  Math.ceil(eventosOrdenados.value.length / porPagina.value)
);

const eventosPaginados = computed(() => {
  const inicio = (paginaActual.value - 1) * porPagina.value;
  return eventosOrdenados.value.slice(inicio, inicio + porPagina.value);
});

function cambiarPagina(pagina) {
  if (pagina >= 1 && pagina <= totalPaginas.value) paginaActual.value = pagina;
}

// ── Métodos ────────────────────────────────────────────────
async function cargarDatos() {
  loading.value = true;
  try {
    const [evs, molds, tips] = await Promise.all([
      getMantenimientos(),
      getMoldes(),
      getTiposEvento(),
    ]);
    eventos.value = evs.map((ev) => ({
      ...ev,
      has_images: ev.imagenes && ev.imagenes.length > 0,
    }));
    catMoldes.value = molds;
    catTipos.value = tips;
  } catch {
    Swal.fire("Error", "Error al cargar datos", "error");
  } finally {
    loading.value = false;
  }
}

function abrirModalNuevo() {
  form.value = {
    molde: "",
    tipo_evento: "",
    maquina: "",
    ciclos_totales: 0,
    fecha_mantenimiento: new Date().toISOString().slice(0, 16),
    descripcion: "",
    requirio_refaccion: false,
    refaccion: "",
    activo: true,
    estatus_molde: "OK",
    comentarios: "",
  };
  selectedFiles.value = [];
  selectedPdf.value = null;
  modalInstance.show();
}

function handlePdfUpload(event) {
  selectedPdf.value = event.target.files[0];
}

function handleFileUpload(event) {
  selectedFiles.value = Array.from(event.target.files);
}

function abrirModalFotos(evento) {
  if (!evento.has_images) {
    Swal.fire({
      icon: "info",
      title: "Sin imágenes",
      text: "No hay evidencias para este evento.",
      confirmButtonColor: "var(--d-brown)",
    });
    return;
  }
  seleccionado.value = evento;
  modalFotosInstance.show();
}

function abrirModalDetalle(evento) {
  seleccionado.value = evento;
  modalDetallesInstance.show();
}

async function guardarIntervencion() {
  guardando.value = true;
  const formData = new FormData();

  Object.keys(form.value).forEach((key) => {
    formData.append(key, form.value[key]);
  });
  selectedFiles.value.forEach((file) => {
    formData.append("archivos_subidos", file);
  });
  if (selectedPdf.value) {
    formData.append("cotizacion_pdf", selectedPdf.value);
  }

  try {
    await crearMantenimiento(formData);
    await cargarDatos();
    modalInstance.hide();
    Swal.fire("Éxito", "Mantenimiento registrado", "success");
  } catch (e) {
    console.error(e);
    Swal.fire("Error", "Revisa los datos ingresados", "error");
  } finally {
    guardando.value = false;
  }
}

async function confirmarEliminar(ev) {
  const res = await Swal.fire({
    text: "Confirmar eliminación de este mantenimiento.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Desactivar",
    color: "var(--d-green)",
    confirmButtonColor: "var(--d-brown)",
  });
  if (res.isConfirmed) {
    await eliminarMantenimiento(ev.id);
    cargarDatos();
  }
}

function formatFecha(fecha) {
  return new Date(fecha).toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function formatFechaCompleta(fecha) {
  if (!fecha) return "";
  return new Date(fecha).toLocaleString("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function exportarExcel() {
  Swal.fire({
    title: "Próximamente",
    text: "Estamos preparando la descarga de reportes en Excel.",
    icon: "info",
    confirmButtonColor: "var(--d-brown)",
  });
}

onMounted(() => {
  cargarDatos();
  modalInstance = new Modal(modalElement.value);
  modalFotosInstance = new Modal(modalFotosElement.value);
  modalDetallesInstance = new Modal(modalDetallesElement.value);
});
</script>

<style scoped>
.divisan-modal-dark {
  background: var(--d-cream) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 20px !important;
  /* Color de la fuente */
  color: var(--d-brown) !important;
}

/* PALETA DIVISAN */
.text-cafe {
  color: var(--d-brown);
}

.text-verde {
  color: var(--d-green);
}

/* BOTONES */
.btn-exportar {
  background-color: var(--d-green);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}

.btn-exportar:hover {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}

.btn-nuevo {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}

.btn-nuevo:hover {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}

/* CARDS Y ENTRADAS */
.divisan-card {
  background-color: var(--d-cream);
  border-radius: 12px;
  border-left: 5px solid var(--d-green);
}

.divisan-input {
  background-color: white !important;
  border: 1px solid var(--d-green);
  color: var(--d-brown) !important;
}

.search-wrapper i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--d-green);
}

.search-wrapper {
  position: relative;
}

.search-wrapper input {
  padding-left: 35px;
}

/* TABLA DIVISAN */
.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: var(--d-radius-lg);
  box-shadow: var(--d-elevation-2);
  overflow: hidden;
}

.table-divisan thead {
  background-color: var(--d-cream);
  color: var(--d-brown);
}

.table-divisan th {
  padding: var(--d-space-4);
  font-weight: 800;
  text-transform: capitalize;
  border: none;
  border-bottom: 1px solid var(--d-border);
}

.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 12px;
}

.table-divisan tbody tr {
  transition: background-color 0.15s ease;
}

.table-divisan tbody tr:hover {
  background-color: var(--d-nav-hover-bg);
}

/* BADGES Y TEXTOS */
.badge-molde {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
  padding: 4px 10px;
  border-radius: 6px;
  font-family: var(--d-font-mono);
  font-size: 0.78rem;
}

.fecha-texto {
  color: var(--d-green);
  font-weight: 700;
  font-size: 0.9rem;
}

.delta-texto {
  color: var(--d-green);
  font-weight: 800;
  font-size: 0.95rem;
}

.badge-evento {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: capitalize;

  background-color: var(--d-green);
  /* Verde Divisan */
  color: #ffffff;

  letter-spacing: 0.5px;
}

/* MODAL */
.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}

.label-divisan {
  color: var(--d-brown);
  font-weight: 700;
}

.divisan-input-modal {
  border: 1px solid var(--d-green);
  border-radius: 8px;
}

/* MÓVIL */
.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: var(--d-radius-lg);
  border-left: 6px solid var(--d-brown);
  box-shadow: var(--d-elevation-1);
  transition: box-shadow 0.15s ease;
}

.divisan-mobile-card:active {
  box-shadow: var(--d-elevation-2);
}

.card-meta-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--d-text-muted);
  margin-bottom: 1px;
}

.card-name {
  color: var(--d-brown);
  font-weight: 700;
  font-size: 0.92rem;
  line-height: 1.25;
}

.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-nuevo-header {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-circular-sm {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-size: 0.85rem;
}
.btn-circular-sm:hover {
  background-color: rgba(96, 108, 56, 0.1);
}
/* Dropdowns con max-height y scroll */
.select-scroll {
  max-height: 200px;
  overflow-y: auto;
}
.select-scroll option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.pagination-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
}
.btn-pag-mobile {
  background: var(--d-cream);
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
  justify-content: center;
}
.btn-pag-mobile:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag-mobile:disabled {
  opacity: 0.35;
  cursor: default;
}
@media (max-width: 991.98px) {
  .btn-header-texto {
    display: none;
  }
  .btn-nuevo-header {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
}
@media (max-width: 768px) {
  #modalEvento .modal-dialog {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}

.detalle-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.detalle-item {
  margin-bottom: 1rem;
}

.detalle-item label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.6);
  display: block;
}

.detalle-item p {
  margin: 0;
  font-weight: 600;
  font-size: 0.95rem;
}

.detalle-bloque {
  background: var(--d-cream);
  border: 1px solid rgba(96, 108, 56, 0.15);
  border-radius: 12px;
  padding: 15px;
}

.detalle-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 800;
  color: var(--d-green);
  display: block;
  margin-bottom: 4px;
}

.detalle-valor {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--d-brown);
}

.detalle-img {
  height: 90px;
  object-fit: cover;
  cursor: pointer;
  transition: 0.2s ease;
}

.detalle-img:hover {
  transform: scale(1.05);
}

.detalle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.detalle-seccion {
  border-top: 1px solid rgba(96, 108, 56, 0.2);
  padding-top: 10px;
}

.detalle-mini-label {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--d-green);
  display: block;
  margin-bottom: 2px;
}

.detalle-mini-valor {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--d-brown);
}
.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 1px solid var(--d-border);
}
.pagination-wrapper {
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background-color: rgba(96, 108, 56, 0.05);
}
.btn-pag {
  background: white;
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-pag:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag:disabled {
  opacity: 0.35;
  cursor: default;
}
</style>
